import React, { useContext } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import { useSpring, animated } from "react-spring";
import AddFilter from "./AddFilter";
import RequestQuote from "./RequestQuote";
import ContactUs from "./ContactUs";
import { StoreContext } from "../../../store/Provider";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: "1.5rem",
  },
}));

const Fade = React.forwardRef(function Fade(props, ref) {
  const { in: open, children, onEnter, onExited, ...other } = props;
  const style = useSpring({
    from: { opacity: 0 },
    to: { opacity: open ? 1 : 0 },
    onStart: () => {
      if (open && onEnter) {
        onEnter();
      }
    },
    onRest: () => {
      if (!open && onExited) {
        onExited();
      }
    },
  });

  return (
    <animated.div ref={ref} style={style} {...other}>
      {children}
    </animated.div>
  );
});

Fade.propTypes = {
  children: PropTypes.element,
  in: PropTypes.bool.isRequired,
  onEnter: PropTypes.func,
  onExited: PropTypes.func,
};

function ModalContainer(props) {
  const classes = useStyles();
  const context = useContext(StoreContext);

  return (
    <Modal
      className={classes.modal + " materialModalContainer"}
      open={context.modalOpen}
      onClose={context.handleModalClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={context.modalOpen}>
        <div className={classes.paper + " materialModal"}>
          {context.modalType === "filterModal" ? (
            <AddFilter />
          ) : context.modalType === "requestQuote" ? (
            <RequestQuote data={props.data} />
          ) : context.modalType === "contact" ? (
            <ContactUs />
          ) : null}
        </div>
      </Fade>
    </Modal>
  );
}

export default ModalContainer;
